/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryResult
 */
export interface QueryResult {
    /**
     * 
     * @type {string}
     * @memberof QueryResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QueryResult
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof QueryResult
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof QueryResult
     */
    documentPageNumber: string;
    /**
     * 
     * @type {object}
     * @memberof QueryResult
     */
    chunk: object;
}

/**
 * Check if a given object implements the QueryResult interface.
 */
export function instanceOfQueryResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "documentPageNumber" in value;
    isInstance = isInstance && "chunk" in value;

    return isInstance;
}

export function QueryResultFromJSON(json: any): QueryResult {
    return QueryResultFromJSONTyped(json, false);
}

export function QueryResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'documentId': json['documentId'],
        'text': json['text'],
        'documentPageNumber': json['documentPageNumber'],
        'chunk': json['chunk'],
    };
}

export function QueryResultToJSON(value?: QueryResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'documentId': value.documentId,
        'text': value.text,
        'documentPageNumber': value.documentPageNumber,
        'chunk': value.chunk,
    };
}

